'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const AngularHelpers=require('../../../../../dist-es6/client/angularCommon/angularHelpers');let

EmiratesDashboardConfig=function(){_createClass(EmiratesDashboardConfig,null,[{key:'$inject',get:function()
{return['$stateProvider']}}]);

function EmiratesDashboardConfig($stateProvider){_classCallCheck(this,EmiratesDashboardConfig);
let feature=AngularHelpers.generateAuthenticatedFeatureConfig('emiratesDashboard',void 0,'./emirates');
$stateProvider.state(feature.fullName,feature.config);
}return EmiratesDashboardConfig}();


module.exports=EmiratesDashboardConfig;
//# sourceMappingURL=emiratesDashboardConfig.js.map
